var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuntosDeContacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_35_2",
    "data-name": "Componente 35 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170738",
    "data-name": "Grupo 170738",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M6,9.133A3.442,3.442,0,1,0,6,2.25,3.442,3.442,0,1,0,6,9.133Zm2.4.983H8.141a4.906,4.906,0,0,1-4.281,0H3.6A3.571,3.571,0,0,0,0,13.655v.885a1.488,1.488,0,0,0,1.5,1.475h9A1.488,1.488,0,0,0,12,14.54v-.885A3.571,3.571,0,0,0,8.4,10.116ZM15,9.133a2.95,2.95,0,1,0-3-2.95A2.976,2.976,0,0,0,15,9.133Zm1.5.983h-.119a4,4,0,0,1-2.762,0H13.5a3.516,3.516,0,0,0-1.741.473A4.456,4.456,0,0,1,13,13.655v1.18c0,.068-.016.132-.019.2H18.5A1.488,1.488,0,0,0,20,13.557,3.469,3.469,0,0,0,16.5,10.116Z",
    transform: "translate(2 2.75)",
    fill: "#47476b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148138",
    "data-name": "Rect\\xE1ngulo 148138",
    width: 20,
    height: 20,
    transform: "translate(2 2)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosDeContacto);
export default __webpack_public_path__ + "static/media/puntos-de-contacto.968f6677b48215a9f104182764f428ac.svg";
export { ForwardRef as ReactComponent };